import useTabParam from '../../hooks/useTabParam';
import PageTitle from "../../components/PageTitle";
import MISCourierUpload from "./MisUpload";
import UploadedMISFiles from "./UploadedMISDetails";
import PillFilters from '../AppointmentDeliveriesV2/shared/PillFilters';

const PILLS = [
    { key: '1', label: 'Upload Bulk Action' },
    { key: '2', label: 'Uploaded File Status' },
];

function CourierMISUpload() {
    const [view, setView] = useTabParam('1');
    return (
        <>
            <PageTitle>Courier MIS Upload</PageTitle>
            <PillFilters pills={PILLS} value={view} onChange={setView} />
            {view === '1' && <MISCourierUpload />}
            {view === '2' && <UploadedMISFiles />}
        </>
    );
}

export default CourierMISUpload;
